import { useState } from 'react';
import Header from '../../components/feature/Header';

const AipaiIndexPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const companies = {
    publics: [
      { name: 'NVIDIA', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/658DFVaNOM1utiIe0LOdJc/e5b0c984e9d59a11ead33fab7adda49e/nvidia.svg' },
      { name: 'Microsoft', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/3bFctB4d9cfLhDOKExc4CG/d5e881f0a8decf637ce5a1e13e817113/microsoft.svg' },
      { name: 'Google', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/6VaVKJjIcUjvS2b16EHdmE/5c64fc2bfded2aa19d95a710f61ffc8d/google.svg' },
      { name: 'Amazon', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/2cZNkc1tXTcPNZWOn6OqNy/2b0eeba5d1499311cb1b4b48acc23795/amazon.svg' },
      { name: 'Tesla', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/4sQCKqztTa01855VPIcIWj/971fa041daaad1e65a40f65f39a08a3e/tesla__1_.svg' },
      { name: 'TSMC', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/72XJqcjy3JJNTkMAN5gvGN/ccca871a289bcceac51074d51f53bbf3/tsmc.svg' },
      { name: 'Meta', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/4Eq5hjCD3RAx2WkARi2EQ8/54c33fb3bd4f0261b6866e46d2e840f5/meta.svg' },
      { name: 'Broadcom', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/7tGck49nQ77lkqHvVftF5h/bb1b74a6fca73851943a2a800e388c70/broadcom.svg' },
      { name: 'Tencent', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/3dG0QxfX699VadnFjqjQcN/928a4d72f5cd809f85c7a3454541e9f9/tencent.svg' },
      { name: 'Netflix', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/6XrTH9rSmGrv7m3fg4mbRD/7fc5f8820788ba262c21602f6f90e6e0/netflix.svg' },
      { name: 'Palantir', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/5KTmbLqNkcxMAKAimhFboW/6699eef23379e18f0916c1a28e0adee5/palantir.svg' },
      { name: 'Alibaba', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/1Kd5omFL4S6l8AU1OWNBpR/ff5762d63a833f9a639c12790eb5b262/alibaba.svg' },
      { name: 'ASML', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/42LxBwdX5r7IF7lb8Z8DJY/49bfef29c5ebba4d3e17ea7bea4aad70/asml.svg' },
      { name: 'AppLovin', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/6KqiGCYNr6tF4LzoJPZflA/01a9ba3cdfb0ae853ce84d687318d989/applovin.svg' },
      { name: 'Xiaomi', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/7CQd0sEoB3dBbzSVcjfpab/92fa52d18475f02fd904438e0f3e28c3/xiaomi.svg' },
      { name: 'Constellation', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/4mNq7O9FTbIhPKaVDNBBQP/9eab367a8336a4c693ab01e45687e54b/constellation.svg' },
      { name: 'Roblox', logo: 'https://static.readdy.ai/image/c35995401d09f3a8501ef616377b3e75/1edc93eea804144ad432691095ae9e1f.png' },
      { name: 'AMD', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/78yvAYbB7rOWFuMHzJQkVh/2d78cb4a68488c315b035435e2a9f8d2/amd.svg' },
      { name: 'Vertiv', logo: 'https://static.readdy.ai/image/c35995401d09f3a8501ef616377b3e75/26fdb1bd58495ea62b7f670866f741cf.png' },
      { name: 'Oracle', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/4LGyGPPKaWikwl8692FNp1/e734dbcfa06a2e1a07b47ad02c57238f/oracle.svg' },
      { name: 'Apple', logo: 'https://public.readdy.ai/ai/img_res/6e495152a3d288796070a61b69f312d1.jpg' },
      { name: 'Robinhood', logo: 'https://readdy.ai/api/search-image?query=Robinhood%20company%20logo%20on%20white%20background%2C%20simple%20clean%20design%2C%20corporate%20branding%20style%2C%20high%20quality%20vector%20logo&width=200&height=60&seq=robinhood-logo&orientation=landscape' }
    ],
    privates: [
      { name: 'Bitcoin', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/3Boa5JOmbXuifmZxQ3wIuX/1de59f9013011c1d58d9499b6196fd78/bitcoin.svg' },
      { name: 'OpenAI', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/7c22tq6zdskCMpL0bf9mbK/3e3d5bff4426c89e4f1e329b10ea2471/openai.svg' },
      { name: 'Ethereum', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/6TA9TPRU9KAtJhdd1bwbFu/0fc49ebe08d3b461cd011dac41128a34/ethereum.svg' },
      { name: 'SpaceX', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/7ehj5Dl2cSEsiTzTWaAhGq/2b3af331b5a6df0b348722e4e70be7e3/spacex.svg' },
      { name: 'Anthropic', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/5fYC7SP8iw1BzdUfsMwtFq/fdaed741f8656351f81108c8916e83e9/anthropic.svg' },
      { name: 'ByteDance', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/5UaH9T4j9WnewtAp5spqWm/f031fd4f9bf9625e45e504437eb05be1/bytedance.svg' },
      { name: 'Stripe', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/2KHL9h9NNeNpraLKrWiauS/e299493848ac29e6ac1cd0b71bef38a0/stripe.svg' },
      { name: 'Databricks', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/7KF3YlQxG136Qqs7vFcQgB/219a57ef9a5972a4829bd993081e7dd3/databricks.svg' },
      { name: 'Revolut', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/4kzYU5xspDN6balyq7FIvI/91e7454c307c228ff23461aea319e64e/revolut.svg' },
      { name: 'xAI', logo: 'https://images.ctfassets.net/iqem6dz8q0mk/YHL198SqnMAVgDk8m8iaZ/9172f29d55e9462f74e2ee20c8d6c8df/xai.svg' }
    ]
  };

  const methodologySteps = [
    {
      number: '01',
      title: 'Top 150 AI & Technology Companies',
      description: 'Comprehensive analysis of leading public and private technology companies with AI capabilities'
    },
    {
      number: '02',
      title: '5-Year Growth Analysis',
      description: 'Evaluation based on hypergrowth potential, innovation metrics, and market positioning'
    },
    {
      number: '03',
      title: 'Risk Assessment',
      description: 'Exclude companies facing multiple compression, revenue challenges, or market headwinds'
    },
    {
      number: '04',
      title: 'AIPAI Index',
      description: 'Final curated list of 40 companies best positioned for AI-driven future'
    }
  ];

  const getFilteredCompanies = () => {
    if (selectedCategory === 'all') {
      return [...companies.publics, ...companies.privates];
    }
    return companies[selectedCategory as keyof typeof companies] || [];
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative px-4 md:px-8 lg:px-16">
        <div className="relative mx-auto max-w-7xl pt-32 md:pt-40">
          <div className="absolute right-0 bottom-0 left-0 grid w-full max-w-7xl grid-cols-3 gap-x-5 md:grid-cols-12 md:gap-x-4 pointer-events-none top-0">
            <div className="relative -left-3 col-start-2 h-full w-px bg-gray-300 md:-left-4 md:col-start-4"></div>
            <div className="hidden md:absolute md:bottom-0 md:left-1/2 md:top-0 md:block md:h-full md:w-px md:bg-gray-300 md:-translate-x-px"></div>
            <div className="relative -left-2 col-start-3 h-full w-px bg-gray-300 md:-left-px md:col-start-10"></div>
          </div>
          <div className="relative col-span-2 grid gap-10 md:col-span-12 md:grid-cols-2 md:gap-4">
            <h1 className="relative col-span-2 whitespace-pre-line text-4xl font-light md:text-5xl lg:text-7xl text-gray-900">
              AIPAI Index
            </h1>
          </div>
        </div>
      </section>

      {/* Description Section */}
      <section className="relative px-4 md:px-8 lg:px-16">
        <div className="relative mx-auto max-w-7xl pt-20 md:pt-20">
          <div className="absolute right-0 bottom-0 left-0 grid w-full max-w-7xl grid-cols-3 gap-x-5 md:grid-cols-12 md:gap-x-4 pointer-events-none top-0">
            <div className="relative -left-3 col-start-2 h-full w-px bg-gray-300 md:-left-4 md:col-start-4"></div>
            <div className="hidden md:absolute md:bottom-0 md:left-1/2 md:top-0 md:block md:h-full md:w-px md:bg-gray-300 md:-translate-x-px"></div>
            <div className="relative -left-2 col-start-3 h-full w-px bg-gray-300 md:-left-px md:col-start-10"></div>
          </div>
          <div className="relative col-span-2 grid gap-10 md:col-span-12 md:grid-cols-6 md:gap-4">
            <p className="relative col-span-6 whitespace-pre-line text-2xl font-light md:text-3xl lg:text-4xl xl:col-span-4 text-gray-900">
              The AIPAI Index Growth & Innovation Index is a curated list of 40 companies best positioned to lead in an AI- and technology-driven world.
            </p>
          </div>
        </div>
      </section>

      {/* Companies Grid Section */}
      <section className="relative px-4 md:px-8 lg:px-16">
        <div className="relative mx-auto max-w-7xl pt-24 pb-20 md:pt-24 md:pb-40">
          <div className="absolute right-0 bottom-0 left-0 grid w-full max-w-7xl grid-cols-3 gap-x-5 md:grid-cols-12 md:gap-x-4 pointer-events-none top-0">
            <div className="relative -left-3 col-start-2 h-full w-px bg-gray-300 md:-left-4 md:col-start-4"></div>
            <div className="hidden md:absolute md:bottom-0 md:left-1/2 md:top-0 md:block md:h-full md:w-px md:bg-gray-300 md:-translate-x-px"></div>
            <div className="relative -left-2 col-start-3 h-full w-px bg-gray-300 md:-left-px md:col-start-10"></div>
          </div>
          
          <div className="relative">
            <div className="rounded-lg border border-gray-300 bg-gray-50">
              <div className="overflow-x-auto">
                <div className="min-w-[1000px] p-5">
                  <div className="grid grid-cols-12 gap-4">
                    {/* Publics Column */}
                    <div className="col-span-9 flex flex-col">
                      <h2 className="text-2xl font-normal mb-4">Publics</h2>
                      <hr className="border-gray-900 mb-0" />
                      <div className="grid grid-cols-3 gap-0">
                        {/* Column 1 */}
                        <div className="table">
                          {companies.publics.slice(0, 10).map((company, index) => (
                            <div key={index} className="table-row h-12">
                              <div className="table-cell border-b border-gray-400 pl-5 align-middle">
                                <div className="flex">
                                  <img 
                                    alt={company.name}
                                    loading="lazy"
                                    className="h-auto max-h-6 max-w-40"
                                    src={company.logo}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        
                        {/* Column 2 */}
                        <div className="table">
                          {companies.publics.slice(10, 20).map((company, index) => (
                            <div key={index} className="table-row h-12">
                              <div className="table-cell border-b border-gray-400 pl-5 align-middle">
                                <div className="flex">
                                  <img 
                                    alt={company.name}
                                    loading="lazy"
                                    className="h-auto max-h-6 max-w-40"
                                    src={company.logo}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        
                        {/* Column 3 */}
                        <div className="table">
                          {companies.publics.slice(20, 30).map((company, index) => (
                            <div key={index} className="table-row h-12">
                              <div className="table-cell border-b border-gray-400 pl-5 align-middle">
                                <div className="flex">
                                  <img 
                                    alt={company.name}
                                    loading="lazy"
                                    className="h-auto max-h-6 max-w-40"
                                    src={company.logo}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Privates/Crypto Column */}
                    <div className="col-span-3 flex flex-col pl-5">
                      <h2 className="text-2xl font-normal mb-4">Privates/Crypto</h2>
                      <hr className="border-gray-900 mb-0" />
                      <div className="table w-full">
                        {companies.privates.map((company, index) => (
                          <div key={index} className="table-row h-12">
                            <div className="table-cell border-b border-gray-400 pl-5 align-middle">
                              <div className="flex">
                                <img 
                                  alt={company.name}
                                  loading="lazy"
                                  className="h-auto max-h-6 max-w-40"
                                  src={company.logo}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-between gap-5 px-5 pt-5 pb-5 md:flex-row">
                <p className="text-sm italic text-gray-500">[Last updated Nov 2025]</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Methodology Section */}
      <section className="relative bg-gray-50 px-4 md:px-8 lg:px-16 text-gray-900">
        <div className="relative mx-auto max-w-7xl py-20 md:py-40">
          <div className="absolute right-0 bottom-0 left-0 grid w-full max-w-7xl grid-cols-3 gap-x-5 md:grid-cols-12 md:gap-x-4 pointer-events-none top-0">
            <div className="relative -left-3 col-start-2 h-full w-px bg-gray-300 md:-left-4 md:col-start-4"></div>
            <div className="hidden md:absolute md:bottom-0 md:left-1/2 md:top-0 md:block md:h-full md:w-px md:bg-gray-300 md:-translate-x-px"></div>
            <div className="relative -left-2 col-start-3 h-full w-px bg-gray-300 md:-left-px md:col-start-10"></div>
          </div>
          
          <div className="relative">
            <div className="relative mb-12 whitespace-pre-line pb-20 text-4xl font-light leading-tight">
              <h2>Our methodology</h2>
            </div>
            
            <div className="flex flex-col items-center justify-between gap-5 rounded-lg border border-gray-300 bg-gray-50 p-11 lg:flex-row lg:flex-wrap lg:gap-0 xl:justify-between xl:gap-5">
              {methodologySteps.map((step, index) => (
                <div key={index} className="flex flex-col items-center">
                  <p className="hidden pb-5 font-mono lg:block">[{step.number}]</p>
                  <div className="flex h-60 w-60 items-center rounded-lg bg-white px-11 lg:h-36 lg:w-36 lg:px-5 xl:h-44 xl:w-44 xl:px-8 xxl:h-60 xxl:w-60 xxl:px-11">
                    {index === 3 ? (
                      <div className="flex h-full w-full items-center justify-center rounded-lg bg-gray-900 text-white">
                        <div className="text-center">
                          <div className="text-2xl font-light lg:text-lg xl:text-xl xxl:text-2xl">AIPAI</div>
                          <div className="text-2xl font-light lg:text-lg xl:text-xl xxl:text-2xl">Index</div>
                        </div>
                      </div>
                    ) : (
                      <p className="text-lg font-light leading-tight lg:text-sm xl:text-base xxl:text-lg">
                        {step.description}
                      </p>
                    )}
                  </div>
                  {index < methodologySteps.length - 1 && (
                    <div className="flex items-center justify-center lg:h-auto lg:px-4">
                      <div className="text-2xl font-light">→</div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-gray-50 px-4 md:px-8 lg:px-16">
        <div className="relative mx-auto max-w-7xl pt-10 text-xs">
          <p className="pb-2">
            All information as of December 2024. The AIPAI Index Growth & Innovation Index represents a curated list of companies best positioned for AI and technology leadership. Company selection is based on comprehensive analysis of growth potential, innovation metrics, and market positioning.
          </p>
          <p className="pb-2">
            The AIPAI Index was created by analyzing 150+ public and private companies across technology, AI, and innovation sectors. Companies were ranked by growth potential and filtered for risk factors including market compression, revenue challenges, and competitive positioning.
          </p>
          <p className="pb-2">
            <strong>This index is for informational purposes only and should not be considered investment advice. Past performance does not guarantee future results. The composition of this index may change without notice.</strong>
          </p>
        </div>
        
        <div className="relative mx-auto max-w-7xl py-16 md:py-24">
          <div className="grid grid-cols-1 gap-24 lg:grid-cols-2">
            <div className="relative">
              <p className="mb-5 border-b border-gray-900 py-2 text-xl text-gray-900 before:relative before:-top-1 before:mr-4 before:inline-block before:h-2 before:w-2 before:min-w-2 before:rounded-full before:bg-gray-900">
                Connect with AIPAI
              </p>
              <div className="md:flex md:flex-1 md:flex-col md:justify-between">
                <ul className="grid grid-cols-2 gap-x-5 gap-y-4">
                  <li className="col-span-2 md:col-span-1">
                    <a className="font-mono gap-4 group inline-flex items-center no-underline cursor-pointer" href="mailto:contact@aipai.com">
                      contact@aipai.com
                    </a>
                  </li>
                  <li className="col-span-2 md:col-span-1">
                    <a className="font-mono gap-4 group inline-flex items-center no-underline cursor-pointer" href="mailto:research@aipai.com">
                      research@aipai.com
                    </a>
                  </li>
                </ul>
                
                <div className="mt-12 text-sm leading-5">
                  <p>
                    AIPAI maintains this website for informational purposes. Any representations regarding investment opportunities are for educational purposes only.
                  </p>
                </div>
                
                <div className="mt-12 text-center">
                  <a href="https://readdy.ai/?origin=logo" className="text-xs text-gray-600 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">
                    Powered by Readdy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AipaiIndexPage;
